import { LocaleService } from "@/services/global-services";
import { Announcement } from "@/services/global-services/models";
import { useDataStore, useLocaleStore } from "@/stores";
import { ArrowRightIcon } from "@heroicons/react/24/outline";
import clsx from "clsx";
import { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

const Notification = () => {
    // TODO: How to display this on smaller screens?
    const activeRegion = useLocaleStore((state) => state.activeRegion);
    const activeLanguage = useLocaleStore((state) => state.activeLanguage);
    const pages = useDataStore((state) => state.pages);

    const [announcement, setAnnouncement] = useState<Announcement | null>(null);

    const localeService = useMemo(
        () => new LocaleService(activeRegion!, activeLanguage!),
        [activeRegion, activeLanguage]
    );

    const { locale } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        localeService
            .getNotification()
            .then((data) => {
                setAnnouncement(data);
            })
            .catch((error) => {
                console.error("Error fetching notification:", error);
            });
    }, [localeService]);

    if (!announcement) return null;

    return (
        <div
            className={clsx([
                "group ml-auto  flex items-center gap-x-2 text-base font-medium shrink-0 opacity-90",
                announcement.type === "Info" ? "text-[#0288D1]" : "text-[#e06615]",
                announcement.internalLink && "cursor-pointer hover:opacity-100",
            ])}
            onClick={() => {
                if (!announcement.internalLink) return;
                const page = pages.find((p) => p.id === announcement.internalLink);
                if (page) {
                    navigate(`/${locale}/${page.url}`);
                }
            }}
        >
            <span
                className={clsx(
                    "group inline-flex items-center gap-x-1.5 rounded-md px-1.5 py-0.5 text-sm/5 font-medium sm:text-xs/5 forced-colors:outline",
                    "uppercase text-white",
                    announcement.type === "Info" ? "bg-[#0288D1]" : "bg-[#e06615]"
                )}
            >
                {announcement.type}
            </span>
            <span className="flex items-center">
                {announcement.message}
                {announcement.internalLink && (
                    <ArrowRightIcon className="size-4 ml-0.5 transition-all duration-500 transit group-hover:translate-x-2" />
                )}
            </span>
        </div>
    );
};

export default Notification;
